import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import template from './myColors.jsx';
import compose from '../../hoc/compose';
import * as colorUtil from '../../util/color';
import displayNames from '../displayNames';
var getDistanceToWhite = function getDistanceToWhite(hexColor) {
  return _(hexColor).thru(colorUtil.hexToHsb).thru(colorUtil.getDistanceToWhite).value();
};
var MyColors = /*#__PURE__*/function (_React$Component) {
  function MyColors(props) {
    var _this;
    _classCallCheck(this, MyColors);
    _this = _callSuper(this, MyColors, [props]);
    _this.state = _this.props.selectedIndex ? {} : {
      selectedIndex: _.indexOf(_this.props.colors, _this.props.value)
    };
    _this.getColorIndex = function () {
      return _.isNumber(_this.props.selectedIndex) ? _this.props.selectedIndex : _this.state.selectedIndex;
    };
    _this.getOptionClassNames = function (color, colorIndex) {
      return {
        light: getDistanceToWhite(color) < 3,
        'color-picker-my-colors-option': true,
        'selected-color': _this.getColorIndex() === colorIndex
      };
    };
    return _this;
  }
  _inherits(MyColors, _React$Component);
  return _createClass(MyColors, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (!this.props.selectedIndex) {
        this.setState({
          selectedIndex: _.indexOf(nextProps.colors, nextProps.value)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);
}(React.Component);
MyColors.displayName = displayNames.MY_COLORS;
MyColors.propTypes = {
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Set the value of the ColorPickerInput. Values can be either:
   * - A single color in HEX, RGB or RGBA
   * - One or more valid css gradient values (see examples here: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Images/Using_CSS_gradients)
   * @linkTypeTo https://developer.mozilla.org/en-US/docs/Web/CSS/color_value
   * @setTypeName color
   */
  value: PropTypes.string,
  /** If set, the index of the selected color from <code>colors</code>` */
  selectedIndex: PropTypes.number,
  /** List of colors (displayed as swatches) */
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** Handles value change. Parameters: <code>color</code> - string with the new color, <code>colorIndex</code> - number indicating the index of the color in <code>colors</code> */
  onChange: PropTypes.func.isRequired,
  /** Handles mouse-enter event on colors. Parameters: <code>color</code> - string with the new color, <code>colorIndex</code> - number indicating the index of the color in <code>colors</code> */
  onColorEnter: PropTypes.func,
  /** Handles mouse-leave event on colors. Parameters: <code>color</code> - string with the new color, <code>colorIndex</code> - number indicating the index of the color in <code>colors</code> */
  onColorLeave: PropTypes.func,
  /** If provided, an Add button is rendered and this function handles its click event */
  addColor: PropTypes.func
};
MyColors.defaultProps = {
  onColorEnter: _.noop,
  onColorLeave: _.noop
};
export default compose(MyColors);